/**
 * ToggleRow — labeled switch row (title + detail + pill switch), extracted
 * from the dashboard superadmin-setup page per the extract-before-second-copy
 * rule. i18n-agnostic: every visible string arrives via props.
 */
export function ToggleRow({
  title,
  detail,
  on,
  busy,
  disabled,
  onToggle,
  onLabel,
  offLabel,
  busyLabel,
}: {
  readonly title: string;
  readonly detail: string;
  readonly on: boolean;
  readonly busy: boolean;
  readonly disabled: boolean;
  readonly onToggle: (next: boolean) => void;
  readonly onLabel: string;
  readonly offLabel: string;
  readonly busyLabel: string;
}) {
  return (
    <div
      style={{
        display: 'flex',
        gap: 16,
        alignItems: 'flex-start',
        padding: 'var(--space-4) 0 0 0',
        marginTop: 'var(--space-4)',
        borderTop: '1px solid var(--color-border)',
      }}
    >
      <div style={{ flex: 1 }}>
        <p style={{ margin: 0, fontWeight: 600 }}>{title}</p>
        <p
          style={{
            margin: '4px 0 0 0',
            fontSize: 'var(--text-meta)',
            color: 'var(--color-on-surface-muted)',
            lineHeight: 1.5,
          }}
        >
          {detail}
        </p>
      </div>
      <div style={{ display: 'grid', gap: 4, justifyItems: 'end', flexShrink: 0 }}>
        <button
          type="button"
          role="switch"
          aria-checked={on}
          aria-label={title}
          disabled={disabled}
          onClick={() => onToggle(!on)}
          style={{
            width: 48,
            height: 28,
            borderRadius: 999,
            border: 'none',
            padding: 3,
            cursor: disabled ? 'wait' : 'pointer',
            background: on ? 'var(--color-primary)' : 'rgba(15,23,42,0.22)',
            display: 'inline-flex',
            justifyContent: on ? 'flex-end' : 'flex-start',
            alignItems: 'center',
            opacity: disabled && !busy ? 0.5 : 1,
            transition: 'background 160ms ease',
          }}
        >
          <span
            aria-hidden
            style={{
              width: 22,
              height: 22,
              borderRadius: 999,
              background: '#ffffff',
              boxShadow: '0 1px 2px rgba(15,23,42,0.3)',
            }}
          />
        </button>
        <span style={{ fontSize: 11, color: 'var(--color-on-surface-muted)' }}>
          {busy ? busyLabel : on ? onLabel : offLabel}
        </span>
      </div>
    </div>
  );
}
